import type { MarketVariants } from '@/lib/i18n'

export type Slide14Copy = {
  title: string
  body: string
  layer1Label: string
  layer1Title: string
  layer1Body: string
  layer2Label: string
  layer2Title: string
  layer2Body: string
  layer3Label: string
  layer3Title: string
  layer3Body: string
  layer4Label: string
  layer4Title: string
  layer4Body: string
  footer: string
}

export const copy: MarketVariants<Slide14Copy> = {
  US: {
    title: 'Your Defense System',
    body: "The goal isn't perfect judgment. It's fewer openings, faster detection, and calmer response with the right support.",
    layer1Label: 'Layer 1',
    layer1Title: 'Protect',
    layer1Body: 'Reduce your exposure with simple security upgrades.',
    layer2Label: 'Layer 2',
    layer2Title: 'Detect',
    layer2Body: 'Spot the warning signs that give scam messaging away.',
    layer3Label: 'Layer 3',
    layer3Title: 'Respond',
    layer3Body: 'Learn what to do the moment something feels wrong.',
    layer4Label: 'Layer 4',
    layer4Title: 'Connect',
    layer4Body: 'Share concerns with someone you trust.',
    footer: "We'll help you build strength in each of these areas.",
  },
  // GB / AU spellings (Defense -> Defence, judgment -> judgement) auto-handled
  // by the toMarketSpelling dictionary. No explicit override needed.
  ar: {
    title: 'نظام حمايتك',
    body: 'الهدف ليس حكماً مثالياً على الأمور، بل ثغرات أقل، واكتشاف أسرع، واستجابة أكثر هدوءاً مع الدعم المناسب.',
    layer1Label: 'الطبقة 1',
    layer1Title: 'الحماية',
    layer1Body: 'قلّل تعرّضك للخطر بتحسينات أمنية بسيطة.',
    layer2Label: 'الطبقة 2',
    layer2Title: 'الاكتشاف',
    layer2Body: 'تعرّف على علامات التحذير التي تفضح رسائل الاحتيال.',
    layer3Label: 'الطبقة 3',
    layer3Title: 'الاستجابة',
    layer3Body: 'تعلّم ما تفعله لحظة تشعر بأن شيئاً ما ليس على ما يرام.',
    layer4Label: 'الطبقة 4',
    layer4Title: 'التواصل',
    layer4Body: 'شارك مخاوفك مع شخص تثق به.',
    footer: 'سنساعدك على بناء قوتك في كل مجال من هذه المجالات.',
  },
}
